(function () {
    'use strict';

    angular
        .module('franchiser.components')
        .controller('ConsultantTypeFranchiserListController', ConsultantTypeFranchiserListController)

    /** @ngInject */
    function ConsultantTypeFranchiserListController(UtilHelper, LoadingHelper, ConsultantTypeService, sweetAlert) {
        const vm = this;

        let isTableSearch = false;
        let forcePaginationReset = false;

        vm.isSearchDisabled = () => {
            if (vm.selectedSearchField && vm.searchText)
                return false;

            return true;
        }

        vm.isClearDisabled = () => {
            if (isTableSearch)
                return false;

            if (vm.selectedSearchField || vm.searchText)
                return false;

            return true;
        }

        vm.doSearch = (event, isFromButton) => {
            if (!vm.isSearchDisabled() && (event && event.keyCode == 13) || isFromButton) {
                forcePaginationReset = true;

                vm.tableCallServer();
            }
        }

        vm.clearSearch = () => {
            vm.selectedSearchField = null;
            vm.searchText = null;

            if (isTableSearch)
                vm.tableCallServer();

            isTableSearch = false;
        }

        vm.tableCallServer = (tableState, stCtrl) => {
            if (!vm.stCtrl && stCtrl)
                vm.stCtrl = stCtrl;

            if (!tableState && vm.stCtrl) {
                vm.stCtrl.pipe();
                return;
            }

            vm.isLoading = true;

            if (forcePaginationReset) {
                tableState.pagination.start = 0;
                forcePaginationReset = false;
            }

            const pagination = tableState.pagination;
            const start = pagination.start || 0;
            const number = pagination.number || 10;

            getConsultantTypes(start, number, tableState);
        }

        vm.openModal = (consultantType = null) => {
            let modalAction = 'NOVO';

            if (consultantType) {
                vm.consultantTypeData = angular.copy(consultantType);
                vm.consultantTypeData.RegistrationDateFormatted = consultantType.RegistrationDate ? moment(consultantType.RegistrationDate).format('DD/MM/YYYY HH:mm') : '';

                modalAction = 'EDITAR';
            }

            vm.modalAction = modalAction;

            $('#consultant-type').appendTo('body').modal('show');
        }

        vm.closeModal = () => {
            vm.consultantTypeData = null;

            vm.consultantTypeForm.reset();

            $('#consultant-type').modal('hide');
        }

        vm.save = () => {
            LoadingHelper.startLoading('.modal-loader');

            if (!vm.consultantTypeData.Id) {
                ConsultantTypeService
                    .post(vm.consultantTypeData)
                    .then(() => successCallback(true), errorCallback);
            } else {
                let consultantTypeData = {
                    Id: vm.consultantTypeData.Id,
                    Title: vm.consultantTypeData.Title
                };

                ConsultantTypeService
                    .put(consultantTypeData)
                    .then(() => successCallback(false), errorCallback);
            }
        }

        vm.delete = consultantTypeId => {
            sweetAlert.swal({
                title: 'Você tem certeza?',
                text: 'Não é possível desfazer essa ação!',
                type: 'warning',
                confirmButtonText: 'Sim, tenho certeza',
                showCancelButton: true,
                cancelButtonText: 'Não, cancelar',
                allowOutsideClick: false,
                allowEscapeKey: false
            }).then(response => {
                if (response.value) {
                    LoadingHelper.startLoading('.loading-holder');

                    ConsultantTypeService
                        .deleteData(consultantTypeId)
                        .then(() => {
                            vm.tableCallServer();
                            LoadingHelper.stopLoading('.loading-holder');
                            UtilHelper.successCallback('delete');
                        }, error => {
                            UtilHelper.errorCallback(error);
                            LoadingHelper.stopLoading('.loading-holder');
                        })
                }
            })
        }

        vm.openMigrationModal = () => {
            vm.consultantTypeOrigin = null;
            vm.consultantTypeDestination = null;

            $('#consultant-type-migration').appendTo('body').modal('show');

            LoadingHelper.startLoading('.modal-loader');

            ConsultantTypeService
                .getAll()
                .then(success => {
                    vm.migrationConsultantTypes = success.Registers;
                    LoadingHelper.stopLoading('.modal-loader');
                }, error => {
                    vm.migrationConsultantTypes = null;

                    UtilHelper.errorCallback(error);
                    LoadingHelper.stopLoading('.modal-loader');
                })
        }

        vm.closeMigrationModal = () => {
            $('#consultant-type-migration').modal('hide');
        }

        vm.migrateRegisters = () => {
            sweetAlert.swal({
                title: 'Você tem certeza?',
                text: 'Todos os consultores serão migrados para o novo tipo. Não é possível desfazer essa ação!',
                type: 'warning',
                confirmButtonText: 'Sim, tenho certeza',
                showCancelButton: true,
                cancelButtonText: 'Não, cancelar',
                allowOutsideClick: false,
                allowEscapeKey: false
            }).then(response => {
                if (response.value) {
                    LoadingHelper.startLoading('.modal-loader');

                    ConsultantTypeService
                        .migrateData(vm.consultantTypeOrigin.Id, vm.consultantTypeDestination.Id)
                        .then(() => {
                            vm.closeMigrationModal();

                            UtilHelper.successCallback('migrate');
                            LoadingHelper.stopLoading('.modal-loader');
                        }, error => {
                            UtilHelper.errorCallback(error);
                            LoadingHelper.stopLoading('.modal-loader');
                        })
                }
            })
        }

        init();

        function getConsultantTypes(skip, perPage, tableState) {
            let parameters = prepareParameters(skip, perPage, tableState);

            ConsultantTypeService
                .getByParameters(parameters)
                .then(success => {
                    vm.consultantTypes = success.Registers;
                    tableState.pagination.numberOfPages = success.NumberOfPages;

                    vm.isLoading = false;
                }, error => {
                    vm.consultantTypes = null;
                    vm.isLoading = false;
                    UtilHelper.errorCallback(error);
                })
        }

        function prepareParameters(skip, perPage, tableState) {
            let params = {
                Skip: skip,
                PerPage: perPage,
                OrderBy: 'RegistrationDate',
                OrderDescending: false
            }

            if (vm.selectedSearchField && vm.searchText)
                isTableSearch = true;

            if (tableState && tableState.sort.predicate) {
                params.OrderBy = tableState.sort.predicate;
                params.OrderDescending = tableState.sort.reverse;
            }

            if (vm.selectedSearchField && vm.searchText)
                params[vm.selectedSearchField.Value] = vm.searchText;

            return params;
        }

        function successCallback(isPost) {
            UtilHelper.successCallback(isPost ? 'create' : 'update');
            vm.tableCallServer();
            vm.closeModal();

            LoadingHelper.stopLoading('.modal-loader');
        }

        function errorCallback(error) {
            LoadingHelper.stopLoading('.modal-loader');
            UtilHelper.errorCallback(error);
        }

        function init() {
            vm.selectedSearchField;
            vm.searchText;
            vm.isLoading = true;

            vm.searchFields = [{
                Value: 'Name',
                Description: 'Título'
            }];
        }
    }
}());